var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Detail Historique Transaction"),
        iconFA: "address-book",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.TransactionList.length > 0
            ? [
                _c("br"),
                _vm._v(" "),
                _c("td", [_vm._v("Informations payement :")]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Nom crediteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.creditor_name
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Identifiant crediteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment
                                  .creditor_identifier
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Compte Bancaire crediteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment
                                  .creditor_bank_account
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Bic créditeur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.creidtor_bic
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Nom Debiteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.debtor_name
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Identifiant débiteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.debtor_identifier
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Bic debiteur")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.debtor_bic
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Référence client")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment
                                  .customer_reference
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Date de création")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.creation_date
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("end_to_end_id")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment.end_to_end_id
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Remittance")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment
                                  .remittance_information
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Date d'execution")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.TransactionList[0].payment
                                  .request_execution_date
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Montant")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.TransactionList[0].payment.amount) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Monnaie")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.TransactionList[0].payment.currency) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "User" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Status")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(
                                _vm.label(_vm.TransactionList[0].payment.status)
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "300px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Direction")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.TransactionList[0].payment.direction) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("td", [_vm._v("Historique :")]),
                _vm._v(" "),
                _c("table", { staticClass: "User-habilitation" }, [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "200px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Status")) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "200px" },
                        },
                        [
                          _vm._v(
                            "\n                              " +
                              _vm._s(_vm.$t("Date de création")) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.TransactionList[0].history, function (result) {
                      return _c(
                        "tr",
                        { key: result, staticClass: "boxRequest" },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { title: result.payment_history.status },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.label(result.payment_history.status))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: {
                                title: result.payment_history.creation_date,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(result.payment_history.creation_date)
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }